import { JournalEntry, JournalEntryCreateRequest } from '../types/accounting';

const FORM_ENTRY_TYPES = ['general', 'adjustment', 'closing', 'opening'] as const;
type FormEntryType = typeof FORM_ENTRY_TYPES[number];

const toFormEntryType = (type: string): FormEntryType =>
  (FORM_ENTRY_TYPES as readonly string[]).includes(type) ? (type as FormEntryType) : 'general';

/** Load an existing entry into the Journal Entry form, keeping its own date */
export const journalEntryToForm = (
  entry: JournalEntry,
  entryDate: string = entry.entry_date
): JournalEntryCreateRequest => ({
  entry_date: entryDate,
  description: entry.description || '',
  reference: entry.reference || '',
  entry_type: toFormEntryType(entry.entry_type),
  lines: entry.lines.map(line => ({
    account_id: line.account_id,
    description: line.description || '',
    debit_amount: line.debit_amount || 0,
    credit_amount: line.credit_amount || 0
  }))
});

/** Start a new entry from an existing one: same description, reference and lines, dated today */
export const copyJournalEntry = (
  entry: JournalEntry,
  today: string = new Date().toISOString().split('T')[0]
): JournalEntryCreateRequest => journalEntryToForm(entry, today);
